import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './LanguageToggle.css';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div className="language-toggle-container">
      <button
        className={`language-toggle ${language === 'bn' ? 'active' : ''}`}
        onClick={toggleLanguage}
        aria-label={language === 'en' ? 'Switch to Bangla' : 'Switch to English'}
        title={language === 'en' ? 'Switch to Bangla (বাংলা)' : 'Switch to English'}
      >
        <span className={`language-option ${language === 'en' ? 'active' : ''}`}>EN</span>
        <span className={`language-option ${language === 'bn' ? 'active' : ''}`}>BN</span>
        <span className="language-slider" style={{ transform: language === 'bn' ? 'translateX(100%)' : 'translateX(0)' }}></span>
      </button>
    </div>
  );
};

export default LanguageToggle;

